import { TrackListItem } from '@/types';
import { api, RequestOptions } from '@/api/api';

export interface TrackServiceListParams {
  start?: number;
  limit?: number;
  compilationsIds?: number[];
  order_column?:
    | 'id'
    | 'likes'
    | 'dislikes'
    | 'listeners_per_month'
    | 'skips_per_month'
    | 'pl_pos'
    | 'tgtr_id';
  order_dir?: 'asc' | 'desc';
  playlistID?: number;
  playlistIDs?: number[];
  excludePlaylistID?: number;
  tagID?: number;
  tagIDs?: number[];
  excludeTagID?: number;
  search?: string;
  tagAndIDs?: number[];
  ids?: number[];
  withSimilar?: boolean;
  statuses?: number[];
}

export interface TrackServiceList {
  total: number;
  list: TrackListItem[];
}

export interface TrackServiceListIDs {
  total: number;
  ids: number[];
}

// eslint-disable-next-line
const trackListQuery = (params: TrackServiceListParams): Record<string, any> => {
  // eslint-disable-next-line
  const query: Record<string, any> = { ...params };

  if (params.compilationsIds) {
    if (params.compilationsIds.length > 0) {
      query['compilations_ids'] = params.compilationsIds.join(',');
    }
    delete query.compilationsIds;
  }

  if (params.playlistIDs) {
    if (params.playlistIDs.length > 0) {
      query['playlist_ids'] = params.playlistIDs.join(',');
    }
    delete query.playlistIDs;
  }

  if (params.tagIDs) {
    if (params.tagIDs.length > 0) {
      query['tag_ids'] = params.tagIDs.join(',');
    }
    delete query.tagIDs;
  }

  if (params.statuses) {
    if (params.statuses.length > 0) {
      query['status'] = params.statuses.join(',');
    }
    delete query.statuses;
  }

  if (params.tagAndIDs) {
    if (params.tagAndIDs.length > 0) {
      query['tag_and_ids'] = params.tagAndIDs.join(',');
    }
    delete query.tagAndIDs;
  }

  if (params.ids && params.ids.length > 0) {
    query['ids'] = params.ids.join(',');
  } else {
    delete query.ids;
  }

  if (params.withSimilar) {
    query['with_similar'] = 1;
  }
  delete query.withSimilar;

  return query;
};

export const TrackService = {
  list(params: TrackServiceListParams, opts?: RequestOptions): Promise<TrackServiceList> {
    return api.get('/track/list', trackListQuery(params), opts);
  },

  // Every id matching the filters in list order, without paging and track details.
  listIDs(
    params: Omit<TrackServiceListParams, 'start' | 'limit' | 'withSimilar'>,
    opts?: RequestOptions
  ): Promise<TrackServiceListIDs> {
    return api.get('/track/list', { ...trackListQuery(params), ids_only: 1 }, opts);
  },

  getMP3DownloadURL(ids: number[]): Promise<{ url: string }> {
    return api.get('/track/download-url', {
      ids: ids.join(',')
    });
  },

  uploadAlbum(req: {
    artistName: string;
    albumName: string;
    albumCover: File | null;
    tracks: File[];
  }) {
    const formData = new FormData();
    formData.set('albumName', req.albumName);
    formData.set('artistName', req.artistName);

    if (req.albumCover) {
      formData.set('albumCover', req.albumCover);
    }

    req.tracks.forEach((tr, i) => {
      formData.set(`tracks[${i}]`, tr);
    });

    return api.post('/track/upload-album', formData);
  }
};
